import { useContext } from "react";
import { useLoaderData } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MenuContext from '../store/MenuContext';

import CartClasses from '../components/Cart/Cart.module.css';

import SuccessComp from '../components/Order/OrderSuccessful';
import UnSuccessComp from '../pages/CreditCardFailed';
import { order as placeOrder } from '../utils/api';
import { cartActions } from '../store/cart';

const Success = () => {
	const orderInfo = useLoaderData();

	const dispatch = useDispatch();
	const cartState = useSelector(state => state.cart);
	const removeFromCartHandler = () => {
			dispatch(cartActions.emptyCart(cartState));
	}
	const menuTheme = useContext(MenuContext);
	console.log(orderInfo);
   return (<div className={CartClasses.testInfo}>
    	    <div className={CartClasses.testInfoContent}>
				{orderInfo.errors && <UnSuccessComp />}
				
				{!orderInfo.errors && <SuccessComp reqdata={{orderInfo}} />}
					{removeFromCartHandler()}
				
			</div>
			</div>
	);
}

export default Success;

export async function loader({ request }) {
	const url = new URL(request.url);
	const searchParams = new URLSearchParams(url.search);

	let ccID = searchParams.get("session_id") || searchParams.get("refNum");

	const response = await placeOrder(sessionStorage.getItem('testsOrdered'), ccID);
	const resData = await response;
	const messages = {};

	if (Object.keys(resData).length) {
		if (resData?.Error) {
			messages.errors = resData.Error;
		} else {
			const reqNum = resData.reqnum;

			messages.success = 1;
			messages.errors = '';
			messages.reqnum = reqNum;
			messages.reqinfo = resData.reqinfo;
			messages.status = resData?.status || null;
			if(messages.status !== null && messages.status !== "CYNERGY Approved" && !messages.status.includes("i3Screen Accepted")) messages.success = '';
		}
	} else {
		messages.errors = "Order errored.";
	}

	return messages;
}
